"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helper_1 = require("./src/helper");
const translations_1 = require("./src/config/translations");
const locale_1 = require("./types/locale");
const DEFAULT_LOCALE = locale_1.Locale.EN_GB;
const DEFAULT_STATIC_BASE_URL_TEMPLATE = 'https://%{subdomain}.babbel.com';
class FooterContent {
    constructor({ options = {}, locale = DEFAULT_LOCALE, staticBaseUrlTemplate = DEFAULT_STATIC_BASE_URL_TEMPLATE }) {
        this.getAllContent = () => {
            var _a, _b;
            const sectionLinksGetters = [
                { handler: this.getPrimaryContent, name: 'primary' },
                { handler: this.getSecondaryContent, name: 'secondary' },
                { handler: this.getIconContent, name: 'icon' }
            ];
            const includedSections = {};
            for (const section of sectionLinksGetters) {
                if (!((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.excludedSections) === null || _b === void 0 ? void 0 : _b.includes(section.name))) {
                    includedSections[section.name] = section.handler();
                }
            }
            return includedSections;
        };
        this.getPrimaryContent = () => this.removeExcludedLinks((0, helper_1.getPrimaryLinks)(this.dataConfig));
        this.getSecondaryContent = () => this.removeExcludedLinks((0, helper_1.getSecondaryLinks)(this.dataConfig));
        this.getIconContent = () => this.removeExcludedLinks((0, helper_1.getIconLinks)(this.dataConfig));
        this.removeExcludedLinks = (sectionLinks) => {
            var _a;
            const excludedLinks = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.excludedLinks) || [];
            return sectionLinks.filter((sectionLink) => !(excludedLinks === null || excludedLinks === void 0 ? void 0 : excludedLinks.includes(sectionLink.id)));
        };
        const i18n = (0, translations_1.getI18NForLocale)(locale).namespace('company');
        this.options = options;
        this.dataConfig = { i18n, locale, staticBaseUrlTemplate };
    }
}
;
exports.default = FooterContent;
//# sourceMappingURL=index.js.map